import React, { createRef } from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import EventEmitter from 'events';
import App from './App';
import Login from './views/Login';
var axiosHelper = require('./Utils/AxiosHelper');

global.emitter = new EventEmitter();
global.axiosHelper = new axiosHelper();
global.isAuth = false;

global.toast = createRef();

const router = createBrowserRouter([
  {
    path: "/",
    element: <App/>,
  },
  {
    path: "/login",
    element: <Login />,
  }
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router}/>
  </React.StrictMode>
);